import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'autoLinkByDescription'
})
export class AutoLinkByDescriptionPipe implements PipeTransform {

  transform(disctext: string): string {
    var regexp_url = /((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g; // ']))/;
    var regexp_makeLink = function(all, url, h, href) {
    	return '<a href="h' + href + '" target="_blank">' + url + ' <i class="fas fa-external-link-alt"></i></a>';
    }

    var temp = disctext.replace(regexp_url, regexp_makeLink);

    var regexp_mail = /[\w\d_¥!#$%&'*+/=?^`{|}~\\-]+([.]?[\w\d_¥!#$%&'*+/=?^`{|}~¥\\-])*[\w\d_¥!#$%&'*+/=?^`{|}~¥\\-]*@[\w\d_¥!#$%&'*+/=?^`{|}~¥\\-]+(?:\.[\w\d_¥!#$%&'*+/=?^`{|}~¥\\-]+)+/g;
    var regexp_makeMailto = function(all) {
      return '<a href="mailto:' + all + '">' + all + ' <i class="fas fa-envelope-square"></i></a>';
    }

    return temp.replace(regexp_mail, regexp_makeMailto);
  }
  
}


// WEBPACK FOOTER //
// ./src/app/pipes/auto-link-by-description.pipe.ts